/**
 * Recursively removes empty values (null, undefined, empty string) from an object
 * @param {object} obj - The object to clean
 * @returns {object | string} - A new object without empty values
 */
export const cleanObject = (obj) => {
  if (!obj || typeof obj !== 'object') return obj;

  if (Array.isArray(obj)) {
    return obj
      .map((item) => cleanObject(item))
      .filter((item) => item !== null && item !== undefined
      && (typeof item !== 'string' || item !== ''));
  }

  return Object.entries(obj).reduce((acc, [key, value]) => {
    const cleanedValue = cleanObject(value);
    if (cleanedValue !== null && cleanedValue !== undefined && cleanedValue !== '') {
      // Handle empty objects
      if (typeof cleanedValue === 'object' && !Array.isArray(cleanedValue)
          && Object.keys(cleanedValue).length === 0) {
        return acc;
      }
      // Handle empty arrays
      if (Array.isArray(cleanedValue) && cleanedValue.length === 0) {
        return acc;
      }
      return { ...acc, [key]: cleanedValue };
    }
    return acc;
  }, {});
};
